module.exports = __webpack_public_path__ + "media/navigation/icon-ambassador-b1c365c3.svg";